/**
 * C-15 ログイン（03 §4.1・D-20①）。M0 S3 から移設（App がルータを持ったため）。
 */

import { ApiError, auth, type ConsoleMe } from "@kenzai/api-client";
import { AuthCard, Button, Field, FormError } from "@kenzai/ui";
import { useState } from "react";

export function Login({ onSuccess }: { onSuccess: (me: ConsoleMe) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSuccess(await auth.login(email, password));
    } catch (err) {
      // FR-110：**サーバが返す文言をそのまま出す**。ここで「メールが違う」等に言い換えると
      // アカウント列挙ができてしまい、サーバ側で文言を揃えた意味が消える。
      setError(err instanceof ApiError ? err.message : "ログインできませんでした。");
      setBusy(false);
    }
  }

  return (
    <AuthCard title="建材オーダー" subtitle="卸コンソールにログイン">
      <form onSubmit={submit} noValidate data-testid="login-form">
        <FormError message={error} />
        <Field
          label="メールアドレス"
          type="email"
          name="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Field
          label="パスワード"
          type="password"
          name="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button fullWidth type="submit" busy={busy}>
          ログイン
        </Button>
      </form>
      {/*
        U2/F3：**「パスワードをお忘れですか？」を解禁**（D-81⑤・M1.5）。
        M1 は「メールで URL を届ける手段が無い」ことを理由にリンクを出さず、運営への連絡を
        案内していた（押しても何も起きない導線を作らないため）。メール基盤（FR-118）が
        入ったので、行き先のある導線に差し替える。**管理経路（卸admin・運営）も残る**＝
        メールが届かない人はそちらで復旧できる（D-81④＝唯一の経路にしない）。
      */}
      <p
        style={{
          marginTop: "var(--kz-space-5)",
          fontSize: "var(--kz-font-size-sm)",
        }}
      >
        <a
          href="/password/forgot"
          data-testid="login-forgot-link"
          style={{ color: "var(--kz-color-primary)" }}
        >
          パスワードをお忘れですか？
        </a>
      </p>
    </AuthCard>
  );
}
